import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
@Injectable({
  providedIn: 'root'
})
export class ProcurementService {
  apiURL: string = environment.apiURL;

  constructor(private http: HttpClient) {}

  /**
   * Get list of materials
   */
  // to do: add hideLoader parametar as optional with default value false
  getProcurementListOfMaterials(data: {skip?: number, limit?: number, search?: string, sector?: string, fromDate?: any, toDate?: any, all?: boolean, sortField?: string, sortValue?: string}): Observable<any> {
    let queryParams = {};

    if (data.skip !== null && data.skip !== undefined) queryParams['skip'] = data.skip;
    if (data.limit !== null && data.skip !== undefined) queryParams['limit'] = data.limit;
    if (data.search) queryParams['search'] = data.search;
    if (data.sector) queryParams['sector'] = data.sector;
    if (data.fromDate) queryParams['fromDate'] = data.fromDate.toISOString();
    if (data.toDate) queryParams['toDate'] = data.toDate.toISOString();
    if (data.sortValue) queryParams[data.sortField] = data.sortValue;
    if (data.all) queryParams['all'] = data.all;

    let params = new HttpParams({ fromObject: queryParams});

    // to do: add headers with ignoreLoadingBar option
    return this.http.get(`${this.apiURL}/procurement/materials`, { params });
  }

  /**
   * Get list of orders
   */
  getProcurementListOfOrders(data: {skip?: number, limit?: number, search?: string, sector?: string, fromDate?: any, toDate?: any, all?: boolean}): Observable<any> {
    let params = new HttpParams()
      .set('skip', data.skip)
      .set('limit', data.limit);

    if (data.search) params = params.append('search', data.search);
    if (data.sector) params = params.append('sector', data.sector);
    if (data.fromDate) params = params.append('fromDate', data.fromDate.toISOString());
    if (data.toDate) params = params.append('toDate', data.toDate.toISOString());
    if (data.all) params = params.append('all', data.all);

    return this.http.get(`${this.apiURL}/procurement/work-orders`, { params });
  }

  /**
   * Get list of reserved materials
   */
  getListOfReservedMaterials(data: {skip?: number, limit?: number, search?: string, sector?: string, fromDate?: any, toDate?: any}): Observable<any> {
    let params = new HttpParams()
      .set('skip', data.skip)
      .set('limit', data.limit);

    if (data.search) params = params.append('search', data.search);
    if (data.sector) params = params.append('sector', data.sector);
    if (data.fromDate) params = params.append('fromDate', data.fromDate.toISOString());
    if (data.toDate) params = params.append('toDate', data.toDate.toISOString());

    return this.http.get(`${this.apiURL}/procurement/reserved`, { params });
  }

  /**
   * Reserve material
   */
  reserveMaterial(data: any): Observable<any> {
    return this.http.patch(`${this.apiURL}/procurement/materials`, data);
  }

  /**
   * Get materials price list
   */
  getMaterialsPriceList(skip?: number, limit?: number, search?: string, isStandard?: string): Observable<any> {
    let params = new HttpParams()
      .set('skip', skip)
      .set('limit', limit);

    if (search) params = params.append('search', search);
    if (isStandard) params = params.append('isStandard', isStandard);

    return this.http.get(`${this.apiURL}/procurement/price-list`, { params });
  }

  /**
   * Update material price
   */
  updateMaterialPrice(id: any, currentUnitPrice: any): Observable<any> {
    return this.http.patch(`${this.apiURL}/materials/${id}/price`, { currentUnitPrice });
  }

  /**
   * Get material details
   */
  getMaterialDetails(id: string): Observable<any> {
    return this.http.get(`${this.apiURL}/materials/${id}`);
  }

  /**
   * Edit material
   */
  editMaterial(id: string, data: any): Observable<any> {
    return this.http.patch(`${this.apiURL}/materials/${id}`, data);
  }

  /**
   * Create new material
   */
  createNewMaterial(data: any): Observable<any> {
    return this.http.post(`${this.apiURL}/materials`, data);
  }

 /**
   * Get all color normatives
   */
  getColorNormatives(): Observable<any> {
    return this.http.get(`${this.apiURL}/color-normatives`);
  }

  /**
   * Change color normatives
   */
  changeColorNormative(materialColorNormativeId: string, value: number): Observable<any> {
    return this.http.patch(`${this.apiURL}/color-normatives/${materialColorNormativeId}`, {value});
  }

  /**
   * Upload materials
   */
  uploadMaterials(data: FormData): Observable<any> {
    return this.http.post(`${this.apiURL}/materials/upload-materials`, data);
  }

  /**
   * Edit currency rate
   */
  editExchangeRate(currencyConverterId: number, data: any): Observable<any> {
    return this.http.patch(`${this.apiURL}/currency-converter/${currencyConverterId}`, data);
  }

  /**
   * Get work order materials from offers
   */
   getWorkOrderMaterialsFromOffer(data: {skip?: number, limit?: number, search?: string, sector?: string}): Observable<any> {
    let params = new HttpParams()
    .set('skip', data.skip)
    .set('limit', data.limit);

    if (data.search) params = params.append('search', data.search);
    if (data.sector) params = params.append('sector', data.sector);

    return this.http.get(`${this.apiURL}/work-orders/materials/offer`, { params });
   }

   /**
    * Set minimum quantity for material
    */
   setMinimumMaterialQuantity(materialId: number, quantity: number): Observable<any> {
    return this.http.post(`${this.apiURL}/procurement/materials/minimum`, {materialId, quantity});
   }

   /**
    * Get next available id for non standard materials
    */
   getNextAvailableMaterialId(): Observable<any> {
    return this.http.get(`${this.apiURL}/materials/next-id`);
  }
}
